const EcommerceGetter = {
    ecomOrders:    state => state.ecomOrders,
    ecomCarts:     state => state.ecomCarts,
    wishlistItems: state => state.wishlistItems,
};

export default EcommerceGetter;
